export enum ShapeType {
  ELLIPSE = 'el',
  FILL = 'fl',
  GRADIENT_FILL = 'gf',
  GRADIENT_STROKE = 'gs',
  GROUP = 'gr',
  MERGE = 'mm',
  OFFSET_PATH = 'op',
  PATH = 'sh',
  RECTANGLE = 'rc',
  REPEATER = 'rp',
  ROUNDED_CORNERS = 'rd',
  STAR = 'sr',
  STROKE = 'st',
  TRIM = 'tm',
  TWIST = 'tw',
  PUCKER_BLOAT = 'pb',
  ZIG_ZAG = 'zz',
}
